import { render } from "./icon-full-screen-close.svg?vue&type=template&id=0cc66868"
const script = {}
script.render = render

export default script